import React, { Component, Suspense } from 'react';
import { Progress } from 'reactstrap';
import Header from '../Header';
import Body from '../Body';
import Footer from '../Footer/Footer';
import * as Constants from '../../utilities/constants/Constants';
import { string } from '../../localization';
import CopyrightInfo from '../Footer/CopyrightInfo/CopyrightInfo';
import { connect } from 'react-redux';
import * as modalActions from '../../redux/modalActions';
import * as homeActions from '../../redux/homeActions';
import * as sidebarAactions from '../../redux/sideBarActions';
import * as fabricCanvasActions from '../../redux/fabricCanvasActions';
import { bindActionCreators } from 'redux';
import './Home.scss';
import { isSignageSuiteProduct } from '../../utilities/HelperFunctions/HelperFunctions';
import * as signageHelperFunctions from '../../utilities/HelperFunctions/SignageHelperFunctions';
import CustomModal from '../../UI/CustomModal/CustomModal';
import LoadingTemplate from '../../components/LoadingTemplate/LoadingTemplate';

const UploadDialogue = React.lazy(() =>
  import('../../components/UploadDialogue/UploadDialogue')
);
const DropBoxUploadDialog = React.lazy(() =>
  import('../../components/UploadDialogue/DropBoxUploadDialog')
);

let reloadTimer;
class Home extends Component {
  state = {
    isModelLoadedOnTime: true
  };

  componentDidMount() {
    const vh = window.innerHeight * 0.01;
    // Then we set the value in the --vh custom property to the root of the document
    document.documentElement.style.setProperty('--vh', `${vh}px`);

    const { dispatchers } = this.props;
    dispatchers.modalActions.initiateSession();
    reloadTimer = window.setInterval(this.checkLoadedOnTime, 45000);
    dispatchers.homeActions.setLandingPage();
  }

  handleSideBar = state => {
    const { dispatchers } = this.props;
    dispatchers.fabricCanvasActions.setSidebarVisibility(state);
  };

  checkLoadedOnTime = () => {
    const { progressData } = this.props;
    this.setState({ isModelLoadedOnTime: progressData > 40 });
    window.clearInterval(reloadTimer);
  };

  showAlert = () => {
    const { dispatchers } = this.props;
    const dict = {
      header: 'Error',
      description:
        'An unexpected error has occured. Click OK to reload the page.',
      stringColor: Constants.DEFAULT_STRING_COLOR,
      onclick: () => {
        window.location.reload();
      },
      buttonTitles: {
        finish: string.OK_KEY,
        cancel: ''
      }
    };
    dispatchers.fabricCanvasActions.setMessageDialogParams(dict);
  };

  render() {
    const {
      dispatchers,
      progressData,
      page,
      showSideBar,
      dropboxUploadDialog,
      uploadDialogue,
      loadingState
    } = this.props;

    const { isModelLoadedOnTime } = this.state;
    if (progressData <= 40) {
      if (!isModelLoadedOnTime) {
        this.showAlert();
      }
      return (
        <>
          <Header
            type={isSignageSuiteProduct() ? 'header-navbar' : 'modal-navbar'}
          />
          <div className='modalBackdrop d-flex justify-content-center align-items-center'>
            <Progress
              className='modalProgressBar'
              animated
              color='info'
              value={progressData * 2.5}
            />
          </div>
          <CopyrightInfo
            isFranceAccount={dispatchers.signageHelperFunctions.isFranceAccount}
          />
        </>
      );
    }

    const canShowModal =
      page === Constants.DESIGN_PAGE &&
      (uploadDialogue || dropboxUploadDialog || loadingState);

    return (
      <>
        {canShowModal && (
          <CustomModal>
            <Suspense
              fallback={
                <div
                  className=' loading-indicator-suspense-fallback'
                  id='loader'
                />
              }
            >
              {uploadDialogue && <UploadDialogue />}
              {dropboxUploadDialog && <DropBoxUploadDialog />}
              {(loadingState || loadingState === '') && (
                <LoadingTemplate type={loadingState} />
              )}
            </Suspense>
          </CustomModal>
        )}
        {/* <Header type='header-navbar' /> */}
        <Body />
        <Footer
          page={page}
          showSideBar={showSideBar}
          handleSideBar={this.handleSideBar}
          isFranceAccount={dispatchers.signageHelperFunctions.isFranceAccount}
          sidebarIsHiddenInDesktop={dispatchers.sidebarAactions.shouldHideSidebarInDesktopMode()}
        />
      </>
    );
  }
}

function mapStateToProps(state) {
  return {
    progressData: state.modal.progressData,
    language: state.home.language,
    showSideBar: state.sideBar.showSideBar,
    viewType: state.fabricCanvas.viewType,
    page: state.pageController.currentPageIndex,
    refresh: state.home.viewOnlyMode,
    loadingState: state.fabricCanvas.loadingState,
    uploadDialogue: state.sideBar.uploadDialogue,
    dropboxUploadDialog: state.sideBar.dropboxUploadDialog
  };
}

function mapDispatchToProps(dispatch) {
  return {
    dispatchers: {
      modalActions: bindActionCreators(modalActions, dispatch),
      fabricCanvasActions: bindActionCreators(fabricCanvasActions, dispatch),
      homeActions: bindActionCreators(homeActions, dispatch),
      signageHelperFunctions: bindActionCreators(
        signageHelperFunctions,
        dispatch
      ),
      sidebarAactions: bindActionCreators(sidebarAactions, dispatch)
    }
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(Home);
